import HeaderIndex from "./Header/HeaderIndex";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getUserInfoes } from "apps/CustomerPanel/Profile/Services";
import { handleSetUserInfoes } from "apps/CustomerPanel/Profile/ClientSideStates";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import LazyLoadComponent from "apps/Common/LazyLoadComponent";

const LayoutIndex: FC<{ wrapperClassNames?: string }> = ({ wrapperClassNames }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();
 
  const getUserInformations = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("access_token");
      if (token) {
        const response: any = await getUserInfoes();
        if (response?.data) {
          dispatch(handleSetUserInfoes({ data: response.data }));
        }
      }
    } catch (error: any) {
      const errorMessage = error?.message || "An error occurred.";
      openNotificationWithIcon("default", errorMessage);
      localStorage.removeItem("access_token");
      navigate("/");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let responseString = searchParams.get("response");
    if (responseString) {
      let response = JSON.parse(responseString);
      if (response?.data) {
        localStorage.setItem("access_token", response?.data);
        getUserInformations();
        navigate("/");
      } else if (response?.message) {
        openNotificationWithIcon("default", response.message);
      }
    }
  }, [searchParams.get("response")]);

  useEffect(() => {
   
    getUserInformations();
  }, [location.pathname]);

  if (isLoading) {
    return <GeneralLoadingSpinner />;
  }

  // ✅ Eğer /ilan/ içeren bir path varsa background rengini #f4f6fb yap
  const isIlanPath = location.pathname.includes("/ilan/");
  const isDetay = location.pathname.includes("/detay");
  const isIlanOrDetay = isIlanPath || isDetay;


  return (
    <>
      <HeaderIndex />
      <div
        className={wrapperClassNames ? wrapperClassNames : "py-2 md:py-6 xl:py-8 xxl:pt-0 !px-2 lg:!px-6 xxl:!px-16"}
        style={{
          overflowX: isDetay ? undefined : "hidden",
          paddingTop: isDetay ? "1.5rem" : "0",
          background: isIlanOrDetay ? "#f4f6fb" : "transparent",
          paddingBottom: isIlanOrDetay ? "0" : "2rem",
        }}
      >
        <Outlet />
      </div>

      <LazyLoadComponent
        importFunc={() => import("./Footer/FooterIndex")}
        fallback={<div>Yükleniyor...</div>}
      />
    </>
  );
};

export default LayoutIndex;
